// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Price.module.scss  */
.Price-module-Button_2tp::before {
  /* stylelint-disable */
  background: linear-gradient(274.62deg, #e3e8fd 2.1%, rgba(255, 255, 255, 0) 52.21%), linear-gradient(274.4deg, #f7f6fe 48.84%, #eee8fe 97.91%);
  /* stylelint-enable */ }

.Price-module-Button_2tpContent {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--price-color-current); }
  .Price-module-Button_2tpContent svg {
    color: var(--price-color-current); }

.Price-module-Button_2tp > div {
  margin: 0 11px; }

.Price-module-Content_2VS {
  display: flex;
  align-items: center; }
  .Price-module-Content_2VS.Price-module-fixedHeight_24r {
    height: 32px; }

.Price-module-Values_1CZ {
  display: flex;
  align-items: center; }

.Price-module-Counter_3Ru {
  border-color: var(--price-border-color-counter); }

.Price-module-OldValue_1nQ {
  position: relative;
  display: inline-block;
  margin-left: 7px;
  font-family: var(--display-font-family);
  color: var(--price-color-old); }
  .Price-module-OldValue_1nQ::after {
    position: absolute;
    top: 40%;
    left: 0;
    width: 100%;
    height: 1.5px;
    content: '';
    background-color: var(--price-color-old);
    transform: rotate(-5deg); }

.Price-module-Badge_28L {
  margin-left: 8px; }

.Price-module-Icon_Woz {
  margin-left: 8px; }

.Price-module-SrOnly_TSY {
  position: absolute;
  overflow: hidden;
  width: 0;
  height: 0; }

.Price-module-columnVariant_3gJ .Price-module-Content_2VS {
  align-items: flex-start; }

.Price-module-columnVariant_3gJ .Price-module-Values_1CZ {
  flex-direction: column;
  align-items: flex-start; }

.Price-module-columnVariant_3gJ .Price-module-OldValue_1nQ {
  margin: 6px 0; }

.Price-module-columnVariant_3gJ .Price-module-Badge_28L {
  margin-top: 4px; }

.Price-module-lSize_lXe .Price-module-OldValue_1nQ {
  font-size: var(--price-old-value-font-size-l);
  line-height: var(--price-old-value-line-heigth-l); }

.Price-module-mSize_1Op .Price-module-OldValue_1nQ {
  font-size: var(--price-old-value-font-size);
  line-height: var(--price-old-value-line-heigth); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Price/Price.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,8IAA8I;EAC9I,qBAAqB,EAAE;;AAEzB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC,EAAE;EACnC;IACE,iCAAiC,EAAE;;AAEvC;EACE,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,mBAAmB,EAAE;EACrB;IACE,YAAY,EAAE;;AAElB;EACE,aAAa;EACb,mBAAmB,EAAE;;AAEvB;EACE,+CAA+C,EAAE;;AAEnD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,6BAA6B,EAAE;EAC/B;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,aAAa;IACb,WAAW;IACX,wCAAwC;IACxC,wBAAwB,EAAE;;AAE9B;EACE,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB,EAAE;;AAEpB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,SAAS,EAAE;;AAEb;EACE,uBAAuB,EAAE;;AAE3B;EACE,sBAAsB;EACtB,uBAAuB,EAAE;;AAE3B;EACE,aAAa,EAAE;;AAEjB;EACE,eAAe,EAAE;;AAEnB;EACE,6CAA6C;EAC7C,iDAAiD,EAAE;;AAErD;EACE,2CAA2C;EAC3C,+CAA+C,EAAE","sourcesContent":["/*  imported from Price.module.scss  */\n.Price-module-Button_2tp::before {\n  /* stylelint-disable */\n  background: linear-gradient(274.62deg, #e3e8fd 2.1%, rgba(255, 255, 255, 0) 52.21%), linear-gradient(274.4deg, #f7f6fe 48.84%, #eee8fe 97.91%);\n  /* stylelint-enable */ }\n\n.Price-module-Button_2tpContent {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--price-color-current); }\n  .Price-module-Button_2tpContent svg {\n    color: var(--price-color-current); }\n\n.Price-module-Button_2tp > div {\n  margin: 0 11px; }\n\n.Price-module-Content_2VS {\n  display: flex;\n  align-items: center; }\n  .Price-module-Content_2VS.Price-module-fixedHeight_24r {\n    height: 32px; }\n\n.Price-module-Values_1CZ {\n  display: flex;\n  align-items: center; }\n\n.Price-module-Counter_3Ru {\n  border-color: var(--price-border-color-counter); }\n\n.Price-module-OldValue_1nQ {\n  position: relative;\n  display: inline-block;\n  margin-left: 7px;\n  font-family: var(--display-font-family);\n  color: var(--price-color-old); }\n  .Price-module-OldValue_1nQ::after {\n    position: absolute;\n    top: 40%;\n    left: 0;\n    width: 100%;\n    height: 1.5px;\n    content: '';\n    background-color: var(--price-color-old);\n    transform: rotate(-5deg); }\n\n.Price-module-Badge_28L {\n  margin-left: 8px; }\n\n.Price-module-Icon_Woz {\n  margin-left: 8px; }\n\n.Price-module-SrOnly_TSY {\n  position: absolute;\n  overflow: hidden;\n  width: 0;\n  height: 0; }\n\n.Price-module-columnVariant_3gJ .Price-module-Content_2VS {\n  align-items: flex-start; }\n\n.Price-module-columnVariant_3gJ .Price-module-Values_1CZ {\n  flex-direction: column;\n  align-items: flex-start; }\n\n.Price-module-columnVariant_3gJ .Price-module-OldValue_1nQ {\n  margin: 6px 0; }\n\n.Price-module-columnVariant_3gJ .Price-module-Badge_28L {\n  margin-top: 4px; }\n\n.Price-module-lSize_lXe .Price-module-OldValue_1nQ {\n  font-size: var(--price-old-value-font-size-l);\n  line-height: var(--price-old-value-line-heigth-l); }\n\n.Price-module-mSize_1Op .Price-module-OldValue_1nQ {\n  font-size: var(--price-old-value-font-size);\n  line-height: var(--price-old-value-line-heigth); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
